<template lang="pug" src="./custom-home-sponsor.pug"></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  props: {
    props: {
      Type: Object,
      default: () => ({})
    }
  },
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-sponsor.vue?c7b0eeec